import { ThemeProvider, useMediaQuery } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { ToastProvider } from './components/common/ToasterContext';
import ToastMessage from './components/common/ToastMessage';
import AdminLayout from './components/Layout';
import AdminOnMobile from './components/MobileScreen';
import AdminManagement from './containers/AdminManagement';
import ContentManagement from './containers/ContentManagement/ContentList';
import Dashboard from './containers/Dashboard';
import ForgotPassword from './containers/ForgotPassword';
import NewMemberRequest from './containers/NewMemberRequest';
import PartnerAndMemberManagement from './containers/PartnerAndMembers';
import ProtectedRoute from './containers/ProtectedRoute';
import ResetPassword from './containers/ResetPassword';
import SelectedPartnerMembers from './containers/SelectedPartnerMember';
import SignIn from './containers/SignIn';
import theme from './theme';

function App() {
    const isMobileOrIpad = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    if (isMobileOrIpad) return <AdminOnMobile />;

    return (
        <div className="App">
            <ThemeProvider theme={theme}>
                <ToastProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<SignIn />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route element={<AdminLayout />}>
                                <Route
                                    path="/dashboard"
                                    element={
                                        <ProtectedRoute>
                                            <Dashboard />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin-management"
                                    element={
                                        <ProtectedRoute>
                                            <AdminManagement />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/partner-member"
                                    element={
                                        <ProtectedRoute>
                                            <PartnerAndMemberManagement />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/partner-member/selected-partner-member"
                                    element={
                                        <ProtectedRoute>
                                            <SelectedPartnerMembers />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/content-management"
                                    element={
                                        <ProtectedRoute>
                                            <ContentManagement />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/new-member-request"
                                    element={
                                        <ProtectedRoute>
                                            <NewMemberRequest />
                                        </ProtectedRoute>
                                    }
                                />
                            </Route>
                        </Routes>
                    </BrowserRouter>
                    <ToastMessage />
                </ToastProvider>
            </ThemeProvider>
        </div>
    );
}

export default App;
